import { formatFromJsonDate } from "../../../../dateConfig";
import LoadingSpinner from "../../../LoadingSpinner";
import Grid from "../../../Grid";
import { StatusLabelStyle } from "../../../renderer/StyleRenderer";
import React, { useEffect, useState } from "react";
import { jobStatusHistory } from "../../../../api/jobApi";
import Header from "../../../Header";
import { Info, User } from "react-feather";
import Dropdown from "../../../input/Dropdown";
import { MODULES } from "../../../../const";
import SearchDropdown from "../../../input/SearchDropdown";
import { getOtherRefSearchDropdown } from "../../../../api/keyvalue";

const JobStatusHistory = ({
  reloadData,
  setReloadData,
  jobId,
  requestId,
  setCurrentStatus,
  setIsLoading,
  isLoading,
  Header,
}) => {
  const [statusHistory, setStatusHistory] = useState([]);
  const [showStatusDetails, setShowStatusDetails] = useState(true);

  useEffect(() => {
    (async () => {
      if (reloadData) {
        setIsLoading(true);
        const response = await jobStatusHistory({ requestId, jobId });
        setCurrentStatus(response && response.length > 0 ? response[0] : null);
        setStatusHistory(
          response && response.length > 0
            ? response.map((sta) => ({
                ...sta,
                rstDateFormated: sta.rstDate
                  ? formatFromJsonDate(sta.rstDate)
                  : "",
              }))
            : [],
        );
        setReloadData(false);
        setIsLoading(false);
      }
    })();
  }, [jobId, requestId, reloadData]);
  return (
    <>
      <h2>Status History</h2>
      <div className="ui segment">
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${showStatusDetails ? "active" : ""}`}
            onClick={() => setShowStatusDetails((prevState) => !prevState)}
          >
            <div>
              Job Information
              <Info size={14} style={{ marginLeft: "10px" }} />
              <i className="dropdown icon"></i>
            </div>
          </div>
          <div className={`content ${showStatusDetails ? "active" : ""}`}>
            <Header />
          </div>
        </div>

        <>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <Grid
              config={[
                {
                  headerName: "Status Code",
                  field: "staRefCode",
                },
                {
                  headerName: "Status",
                  field: "rstDescription",
                  cellRenderer: StatusLabelStyle,
                  cellRendererParams: (params) => ({
                    height: "90px",
                  }),
                  minWidth: 170,
                  cellStyle: (params) => ({
                    backgroundColor: params.data.staColor
                      ? params.data.staColor
                      : "white",
                  }),
                },
                {
                  headerName: "Date",
                  field: "rstDateFormated",
                  minWidth: 250,
                },
                {
                  headerName: "Created By",
                  field: "rstUser",
                },
              ]}
              content={statusHistory}
            />
          )}
        </>
      </div>
    </>
  );
};

export default JobStatusHistory;
